import {isValidDate} from './date';

/**
 * Checks if the spender related fields are complete.
 *
 * @param {*} spender
 * @param {[]} materials
 * @param {[]} accounts
 * @param {LabelValue} companyCode
 * @param {LabelValue} purchaseOrganization
 * @param {LabelValue} defaultPlant
 * @param {*} defaultDeliveryAddress
 * @param {*} defaultRequestedDeliveryDate
 * @param {string} validityStart
 * @param {string} validityEnd
 * @param {LabelValue} wayOfBuying
 * @return {boolean}
 */
export const isSpenderIncomplete = (
    spender,
    materials,
    accounts,
    companyCode,
    purchaseOrganization,
    defaultPlant,
    defaultDeliveryAddress,
    defaultRequestedDeliveryDate,
    validityStart,
    validityEnd,
    wayOfBuying,
) => {
    const isWayOfBuyingFO = wayOfBuying?.value === 'FO';

    return (
        !spender.value ||
        !companyCode.value ||
        !purchaseOrganization.value ||
        !defaultPlant.value ||
        !defaultDeliveryAddress.name ||
        (isWayOfBuyingFO && (!isValidDate(validityStart) || !isValidDate(validityEnd))) ||
        (!isWayOfBuyingFO && !isValidDate(defaultRequestedDeliveryDate)) ||

        !materials.every((material) =>
            material.description &&
            material.quantity &&
            material.unit &&
            material.price &&
            material.currency.value &&
            material.per &&
            material.requestedDeliveryDate &&
            material.plant.value &&
            material.deliveryAddress.name,
        ) ||

        !accounts.every((account) => {
            if (!account.accountType?.label) {
                return false;
            }

            const accountTypeLabel = account.accountType.label.toLowerCase();

            if (accountTypeLabel === 'cost center') {
                return account.costCenter.value && account.glNumber.value;
            } else if (accountTypeLabel === 'wbs / project') {
                return account.wbs.value && account.glNumber.value;
            } else if (accountTypeLabel === 'profit center') {
                return account.profitCenter.value && account.glNumber.value;
            } else if (accountTypeLabel === 'statistical wbs') {
                return account.wbs.value && account.costCenter.value && account.glNumber.value;
            }
        })
    );
};

/**
 * Checks if the requester related fields are complete.
 *
 * @param {*} requester
 * @param {LabelValue} wayOfBuying
 * @param {LabelValue} purchasingGroup
 * @param {[]} materials
 * @param {string} vendorCode
 * @param {LabelValue} companyCode
 * @return {boolean}
 */
export const isRequesterIncomplete = (
    requester,
    wayOfBuying,
    purchasingGroup,
    materials,
    vendorCode,
    companyCode,
) => {
    return (
        !requester.value ||
        !wayOfBuying.value ||
        !purchasingGroup.value ||
        !materials.every((material) => material.taxCode.value) ||
        (companyCode.value.startsWith('CH') && Array.from(String(vendorCode)).every((char) => char === '9'))
    );
};
